/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AclAccessRoleList } from '../../models/acl-access-role-list';

export interface GetAclAccessRoles$Params {
  orid: number;
}

export function getAclAccessRoles(http: HttpClient, rootUrl: string, params: GetAclAccessRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AclAccessRoleList>>> {
  const rb = new RequestBuilder(rootUrl, getAclAccessRoles.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AclAccessRoleList>>;
    })
  );
}

getAclAccessRoles.PATH = '/api/AclRole/{orid}';
